import { forwardRef } from "react";

import { SVGProps, Ref } from "react";

interface SvgThumbsDownProps extends SVGProps<SVGSVGElement> {
  title?: string;
  titleId?: string;
}

function SvgThumbsDown(
  { title, titleId, ...props }: SvgThumbsDownProps,
  ref: Ref<SVGSVGElement>,
) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : "Thumbs down"}
      <path
        d="M22 4L20 4C19.45 4 19 4.45 19 5L19 14C19 14.55 19.45 15 20 15L22 15L22 4ZM2.17 11.12C2.06 11.37 2 11.64 2 11.92L2 13C2 14.1 2.9 15 4 15L9.5 15L8.58 19.65C8.53 19.87 8.56 20.11 8.66 20.31C8.89 20.76 9.18 21.17 9.54 21.53L10 22L16.41 15.59C16.79 15.21 17 14.7 17 14.17L17 6.34C17 5.05 15.95 4 14.66 4L6.56 4C5.85 4 5.2 4.37 4.84 4.97L2.17 11.12V11.12Z"
        fill="#082C88"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgThumbsDown);
export default ForwardRef;
